import {CheckIcon, SparkleIcon, XIcon} from '@primer/octicons-react'
import {IconButton} from '@primer/react'
import {clsx} from 'clsx'

export interface AllowedValuesSuggestionProps {
  suggestedValues: string[]
  onAccept: () => void
  onDismiss: () => void
  className?: string
}

export function AllowedValuesSuggestion({
  suggestedValues,
  onAccept,
  onDismiss,
  className,
}: AllowedValuesSuggestionProps) {
  const [firstSuggestion] = suggestedValues

  if (!firstSuggestion) {
    return null
  }

  return (
    <div
      data-testid="allowed-values-suggestion"
      className={clsx('d-flex flex-items-center gap-3 p-1 tmp-px-3 color-bg-subtle border-top', className)}
    >
      <SparkleIcon size="small" className="color-fg-muted mr-1" />

      <div className="d-flex gap-2">
        <strong>{firstSuggestion}</strong>
        {suggestedValues.length > 1 && <span className="color-fg-muted"> + {suggestedValues.length - 1} more</span>}
      </div>

      <div className="d-flex flex-items-center gap-2 ml-auto">
        <div className="d-flex gap-1">
          <IconButton
            size="small"
            variant="invisible"
            icon={CheckIcon}
            aria-label="Accept suggestion"
            onClick={onAccept}
          />
          <IconButton
            size="small"
            variant="invisible"
            icon={XIcon}
            aria-label="Dismiss suggestion"
            onClick={onDismiss}
          />
        </div>
      </div>
    </div>
  )
}
